import { render, staticRenderFns } from "./LocalVideoControlButton.vue?vue&type=template&id=420763c6&scoped=true"
import script from "./LocalVideoControlButton.vue?vue&type=script&lang=js"
export * from "./LocalVideoControlButton.vue?vue&type=script&lang=js"
import style0 from "./LocalVideoControlButton.vue?vue&type=style&index=0&id=420763c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420763c6",
  null
  
)

export default component.exports